@if ((exhibitorLoading$ | async) === false) { @if (exhibitor$ | async; as exhibitor) {
<section class="exhibitor-details">
  <bau365-exhibitor-section-header
    [exhibitor]="exhibitor"
    [parent]="parentExhibitor$ | async"
    [isBauInsights]="(isBauInsights$ | async) === true"
    [size]="size$ | async"
    [socialShareUrl]="socialShareUrl"
    [breadcrumbElements]="breadcrumbElements"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareDialogOpened)="trackShareDialogOpened($event)"
    (shareDialogClicked)="trackShareDialogClicked($event)"></bau365-exhibitor-section-header>
  <section class="exhibitor-details-wrapper">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <mat-tab-group
            class="tabs-spread exhibitor-page-tabs"
            (selectedTabChange)="tabChange($event)"
            [selectedIndex]="tabIndex">
            <mat-tab
              [label]="(isBauInsights$ | async) ? tabNameCompany : tabNameExhibitor"
              [aria-label]="(isBauInsights$ | async) ? tabNameCompany : tabNameExhibitor">
              <bau365-exhibitor-section-info [exhibitor]="exhibitor"></bau365-exhibitor-section-info>
              <bau365-exhibitor-section-media
                [exhibitor]="exhibitor"
                (tabChange)="trackTabChange($event)"
                (swiperInteraction)="swiperInteraction($event)"
                (imageZoomChange)="imageZoomed = $event">
              </bau365-exhibitor-section-media>
              @if ((isBauInsights$ | async) !== true) {
              <bau365-exhibitor-section-exhibitor-references
                [exhibitor]="exhibitor"
                [parent]="parentExhibitor$ | async"
                [coExhibitors]="coExhibitors$ | async"
                [size]="size"
                [cardSliderConfig]="cardSliderConfig$ | async"
                [imageZoomed]="imageZoomed"></bau365-exhibitor-section-exhibitor-references>
              }
              <bau365-exhibitor-section-brands
                [brandsList]="exhibitor.brands"
                [imageZoomed]="imageZoomed"
                (initialized)="brandsSection = $event"></bau365-exhibitor-section-brands>
              <bau365-exhibitor-section-downloads
                [exhibitor]="exhibitor"
                (download)="trackDownload($event.element, $event.fileName)"></bau365-exhibitor-section-downloads>
              <bau365-exhibitor-section-links
                [exhibitor]="exhibitor"
                (linkClick)="
                  trackClick($event.element, $event.linkType, $event.linkText, $event.contactPersonId)
                "></bau365-exhibitor-section-links>
              <bau365-exhibitor-section-contact-persons
                [exhibitor]="exhibitor"
                [size]="size"
                (linkClick)="
                  trackClick($event.element, $event.linkType, $event.linkText, $event.contactPersonId)
                "></bau365-exhibitor-section-contact-persons>
              <bau365-exhibitor-section-contact
                [exhibitor]="exhibitor"
                [showSendBusinessCard]="togglesFacade.flag('show-send-business-card') | async"
                (linkClick)="
                  trackClick($event.element, $event.linkType, $event.linkText, $event.contactPersonId)
                "></bau365-exhibitor-section-contact>
            </mat-tab>
            <mat-tab
              [label]="(isBauInsights$ | async) ? tabNameCompanyContent : tabNameExhibitorContent"
              [aria-label]="(isBauInsights$ | async) ? tabNameCompanyContent : tabNameExhibitorContent">
              @if ( (exhibitorProductsLoading$ | async) === true || ((exhibitorProducts$ | async)?.length ?? 0) > 0 ||
              (exhibitorPostsLoading$ | async) === true || ((exhibitorPosts$ | async)?.length ?? 0) > 0 ||
              (exhibitorEventsLoading$ | async) === true || ((exhibitorEvents$ | async)?.length ?? 0) > 0) { @if (
              (exhibitorProductsLoading$ | async) === true || ((exhibitorProducts$ | async)?.length ?? 0) > 0 ) {
              <section class="exhibitor-slider-container">
                <div class="mdc-layout-grid no-offset-x">
                  <div class="mdc-layout-grid__inner">
                    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                      <div class="exhibitor-slider-header">
                        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-portfolio">
                          Portfolio
                        </h2>
                        @if (fairId$ | async; as fairId) {
                        <a
                          class="show-all"
                          i18n="@@featureExhibitorDetails-pageTabExhibitor-showAll"
                          (click)="trackShowAll('products')"
                          [routerLink]="['/fairs', fairId, 'search']"
                          [queryParams]="{
                            searchTypes: 'PRODUCT',
                            filter: stringifyFilter({ exhibitor: [exhibitor.id] })
                          }">
                          Alle anzeigen
                        </a>
                        }
                      </div>
                      <hr />
                      @if ((exhibitorProductsLoading$ | async) === false) {
                      <bau365-product-card-list
                        *ngIf="exhibitorProducts$ | async as products"
                        [products]="products"
                        [exhibitor]="exhibitor"
                        [size]="size$ | async"
                        [cardSliderConfig]="cardSliderConfig$ | async"
                        context="exhibitor-details"
                        [imageZoomed]="imageZoomed"
                        [moreRouterLink]="['/fairs', fairId$ | async, 'search']"
                        [moreQueryParams]="{
                          searchTypes: 'PRODUCT',
                          filter: stringifyFilter({ exhibitor: [exhibitor.id] })
                        }"></bau365-product-card-list>
                      } @else {
                      <section class="loading-animation loading-animation--relative">
                        <planone-loading-animation></planone-loading-animation>
                      </section>
                      }
                    </div>
                  </div>
                </div>
              </section>
              } @if ((exhibitorEventsLoading$ | async) === true || ((exhibitorEvents$ | async)?.length ?? 0) > 0) {
              <section class="exhibitor-slider-container">
                <div class="mdc-layout-grid no-offset-x">
                  <div class="mdc-layout-grid__inner">
                    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                      <div class="exhibitor-slider-header">
                        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-events">
                          Events
                        </h2>
                        @if (fairId$ | async; as fairId) {
                        <a
                          class="show-all"
                          i18n="@@featureExhibitorDetails-pageTabExhibitor-showAll"
                          (click)="trackShowAll('events')"
                          [routerLink]="['/fairs', fairId, 'search']"
                          [queryParams]="{
                            searchTypes: 'EVENT',
                            filter: stringifyFilter({ exhibitor: [exhibitor.id] })
                          }">
                          Alle anzeigen
                        </a>
                        }
                      </div>
                      <hr />
                      @if ((exhibitorEventsLoading$ | async) === false) { @if (exhibitorEvents$ | async; as events) {
                      <bau365-event-card-list
                        [events]="events"
                        [exhibitor]="exhibitor"
                        [size]="size$ | async"
                        [cardSliderConfig]="cardSliderConfig$ | async"
                        context="exhibitor-details"
                        [imageZoomed]="imageZoomed"
                        [moreRouterLink]="['/fairs', fairId$ | async, 'search']"
                        [moreQueryParams]="{
                          searchTypes: 'EVENT',
                          filter: stringifyFilter({ exhibitor: [exhibitor.id] })
                        }"></bau365-event-card-list>
                      } } @else {
                      <section class="loading-animation loading-animation--relative">
                        <planone-loading-animation></planone-loading-animation>
                      </section>
                      }
                    </div>
                  </div>
                </div>
              </section>
              } @if ((exhibitorPostsLoading$ | async) === true || ((exhibitorPosts$ | async)?.length ?? 0) > 0) {
              <section class="exhibitor-slider-container">
                <div class="mdc-layout-grid no-offset-x">
                  <div class="mdc-layout-grid__inner">
                    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                      <div class="exhibitor-slider-header">
                        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-posts">
                          Beiträge
                        </h2>
                        @if (fairId$ | async; as fairId) {
                        <a
                          class="show-all"
                          i18n="@@featureExhibitorDetails-pageTabExhibitor-showAll"
                          (click)="trackShowAll('posts')"
                          [routerLink]="['/fairs', fairId, 'search']"
                          [queryParams]="{
                            searchTypes: 'POST',
                            filter: stringifyFilter({ exhibitor: [exhibitor.id] })
                          }">
                          Alle anzeigen
                        </a>
                        }
                      </div>
                      <hr />
                      @if ((exhibitorPostsLoading$ | async) === false) { @if (exhibitorPosts$ | async; as posts) {
                      <bau365-post-card-list
                        [posts]="posts"
                        [exhibitor]="exhibitor"
                        [size]="size$ | async"
                        [cardSliderConfig]="cardSliderConfig$ | async"
                        context="exhibitor-details"
                        [imageZoomed]="imageZoomed"
                        [moreRouterLink]="['/fairs', fairId$ | async, 'search']"
                        [moreQueryParams]="{
                          searchTypes: 'POST',
                          filter: stringifyFilter({ exhibitor: [exhibitor.id] })
                        }"></bau365-post-card-list>
                      } } @else {
                      <section class="loading-animation loading-animation--relative">
                        <planone-loading-animation></planone-loading-animation>
                      </section>
                      }
                    </div>
                  </div>
                </div>
              </section>
              } } @else {
              <div
                class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4-phone mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--start-2-tablet mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--start-4-desktop no-results-panel">
                <img class="no-results-message__img" src="assets/search/person-searching.svg" />
                <p class="no-results-message__text">
                  <span class="no-results-text" i18n="@@featureExhibitor-fair-tab-no-results">Keine Inhalte</span>
                </p>
              </div>
              }
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </section>
</section>
} @else { @if ((exhibitorError$ | async) !== '500') {
<bau365-shell-page-not-found></bau365-shell-page-not-found>
} @if ((exhibitorError$ | async) === '500') {
<bau365-shell-page-service-unavailable></bau365-shell-page-service-unavailable>
} } } @else {
<section class="loading-animation">
  <planone-loading-animation></planone-loading-animation>
</section>
}
<ng-template #loading>
  <section class="loading-animation">
    <planone-loading-animation></planone-loading-animation>
  </section>
</ng-template>
